import React, { memo } from 'react';

/**
 * ListingCardSkeleton
 * Shimmer loading skeleton for listing cards
 * Shows while listing data is being fetched
 */
const ListingCardSkeleton = memo(({ compact = false }) => {
  return (
    <div 
      className={`${compact ? 'rounded-xl' : 'rounded-2xl'} overflow-hidden flex flex-col border border-border bg-card animate-pulse`}
      data-testid="listing-card-skeleton"
    >
      {/* Image placeholder */}
      <div className={`${compact ? 'aspect-[4/3]' : 'aspect-[4/3]'} bg-muted relative overflow-hidden`}>
        {/* Shimmer effect */}
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      </div>
      
      {/* Content placeholder */}
      <div className={`${compact ? 'p-2 sm:p-3' : 'p-3 sm:p-4'} space-y-3`}>
        {/* Category */}
        {!compact && (
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-muted rounded" />
            <div className="h-3 w-16 bg-muted rounded" />
          </div>
        )}
        
        {/* Title */}
        <div className="space-y-1.5">
          <div className={`${compact ? 'h-3' : 'h-4'} bg-muted rounded w-full`} />
          <div className={`${compact ? 'h-3' : 'h-4'} bg-muted rounded w-3/4`} />
        </div>
        
        {/* Price */}
        <div className={`${compact ? 'h-5' : 'h-6'} bg-muted rounded w-24`} />
        
        {/* Location & Views */}
        <div className="flex items-center justify-between pt-2 border-t border-border">
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 bg-muted rounded" />
            <div className="h-3 w-20 bg-muted rounded" />
          </div>
          <div className="flex items-center gap-1">
            <div className="w-3 h-3 bg-muted rounded" />
            <div className="h-3 w-8 bg-muted rounded" />
          </div>
        </div>
        
        {/* Seller - only in non-compact mode */}
        {!compact && (
          <div className="flex items-center gap-2 pt-3 border-t border-border">
            <div className="w-7 h-7 bg-muted rounded-full" />
            <div className="h-3 w-24 bg-muted rounded" />
          </div>
        )}
      </div>
    </div>
  );
});

ListingCardSkeleton.displayName = 'ListingCardSkeleton';

export default ListingCardSkeleton;
